import { type Namespace } from 'i18next';

export const screeningsI18n = ['common', 'screenings'] satisfies Namespace;
